import { useCurrentUser } from 'hooks/api/use-current-user';

import { useApiGetConversations } from '../../hooks/use-api-get-conversations';

import { MARK_PANEL_TITLE } from '../mark-panel.constants';

interface MarkPanelConversationSummary {
  id: string;
  name?: string;
}

const isConversationSummary = (
  item: unknown
): item is MarkPanelConversationSummary =>
  typeof item === 'object' &&
  item !== null &&
  typeof (item as { id?: unknown }).id === 'string';

export const useMarkPanelTitle = (
  conversationId: string | null,
  clientId: string
): string => {
  const currentUser = useCurrentUser();

  const { data: conversations } = useApiGetConversations({
    oktaUserId: currentUser?.data?.oktaUserId as string,
    clientId,
  });

  if (!conversationId) return MARK_PANEL_TITLE;

  const conversationList = Array.isArray(conversations) ? conversations : [];
  const conversation = conversationList.find(
    (item): item is MarkPanelConversationSummary =>
      isConversationSummary(item) && item.id === conversationId
  );

  return conversation?.name ? conversation.name : MARK_PANEL_TITLE;
};
